import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

export const setAppLoadError: GlobalStateCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.appLoadError = true;
    });
  };
